import React, { Component, useMemo } from "react";
import DataTable from "../../_Components/DataTable";
import SplitNumber from "../../_Components/SplitNumber";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import _ from "lodash";

function DataGridAmusementServices({ data }) {
  const columns = useMemo(
    () => [
      {
        accessor: "noRow",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "description",
        Header: "توضیحات",
        minWidth: "100px",
      },
      {
        Header: "مبلغ",
        align: "center",
        minWidth: 100,
        Cell: ({ row }) =>
          row.original.balanceType == 1 ? (
            <div className="text-center text-green">
              <ArrowUpwardIcon className=" " />
              <SplitNumber number={row.original.amount} />
            </div>
          ) : (
            <div className="text-center text-danger">
              <ArrowDownwardIcon className="" />
              <SplitNumber number={row.original.amount} />
            </div>
          ),
      },
      {
        Header: "وضعیت",
        align: "center",
        width: 100,
        Cell: ({ row }) =>
          row.original.balanceType == 1 ? (
            <div className="text-center text-green bg-light-green rounded-pill py-1">
              افزایش موجودی
            </div>
          ) : (
            <div className="text-center text-danger bg-light-danger rounded-pill py-1">
              کاهش موجودی
            </div>
          ),
      },
      {
        Header: "تاریخ",
        align: "center",
        minWidth: 100,
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.completionDate} - {row.original.completionTime}
          </div>
        ),
      },
      // {
      //     accessor: "trackingCode",
      //     Header: "کد پیگیری",
      //     align: "center",
      //     minWidth: '100px',
      // },
      {
        Header: "موجودی",
        align: "center",
        minWidth: "100px",
        Cell: ({ row }) => (
          <div className="text-center">
            <SplitNumber number={row.original.riallBalance} />
          </div>
        ),
      },
      // {
      //     Header: 'عملیات',
      //     accessor: '',
      //     minWidth: 150,
      //     align: "center",
      //     Cell: ({ row }) => (
      //         <div className="text-center">
      //             {/* ویرایش */}
      //             <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/userWithdrawalsDetails/${row.original.id}`}   >
      //                 <i className='far fa-edit text-small'></i>
      //             </Link>
      //         </div>
      //     )
      // }
    ],
    []
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAmusementServices;
